import { useState } from 'react';
import { BigNumber, ethers, providers } from 'ethers'
import { SC_ADDRESS, USDT_ADDRESS } from '../../constants/eth/addresses';
import HPContract from '../eth-abis/HPContract.json'
import usdt from "../eth-abis/usdt.json"
import { notify } from '../../utils/notifications';
declare let window: any;
async function requestAccount() {
    await window.ethereum.request({ method: 'eth_requestAccounts' });
}
export async function HouseDeposit(amount: number) {
    if (typeof window.ethereum !== 'undefined') {
        console.log(amount)
        await requestAccount()
        const provider = new providers.Web3Provider(window.ethereum)
        const signer = provider.getSigner()
        const SC = new ethers.Contract(SC_ADDRESS, HPContract.abi, signer)
        const USDToken = new ethers.Contract(USDT_ADDRESS, usdt.usdt, signer)
        try {
            let transaction1 = await USDToken.approve(SC.address, amount * 10 ** 6)
            await transaction1.wait()
            let transaction2 = await SC.process_deposit(amount)
            transaction2.wait()
            return transaction2.hash
        } catch (err: any) {
            console.log("Error: ", err)
            if (err.data) {
                return ('Error: ' + err.data.message)
            }
            return ('Error: ' + err.message)
        }
    }
    else {
        return "Error: Wallet not connected"
    }
}

export async function HouseWithdraw(amount: number) {
    if (typeof window.ethereum !== 'undefined') {
        console.log(amount)
        await requestAccount()
        const provider = new providers.Web3Provider(window.ethereum)
        const signer = provider.getSigner()
        const SC = new ethers.Contract(SC_ADDRESS, HPContract.abi, signer)
        const USDToken = new ethers.Contract(USDT_ADDRESS, usdt.usdt, signer)
        try {
            let transaction1 = await SC.approve(SC.address, amount * 10 ** 6)
            await transaction1.wait()
            let transaction2 = await SC.process_withdrawal(amount)
            transaction2.wait()
            return transaction2.hash
        } catch (err: any) {
            console.log("Error: ", err)
            if (err.data) {
                return ('Error: ' + err.data.message)
            }
            return ('Error: ' + err.message)
        }
    }
    else {
        return "Error: Wallet not connected"
    }
}
